
import React, { useState } from 'react';
import './CreateStoryModal.css';
import { useApp } from '../../context/AppContext';

interface CreateStoryModalProps {
  onClose: () => void;
}

const CreateStoryModal: React.FC<CreateStoryModalProps> = ({ onClose }) => {
  const { createPost } = useApp();
  const [mediaType, setMediaType] = useState<'image' | 'video'>('image');
  const [preview, setPreview] = useState<string | null>(null);
  const [posting, setPosting] = useState(false);
  const [success, setSuccess] = useState(false);

  const generatePlaceholder = () => {
    const colors = ['#6366f1', '#8b5cf6', '#ec4899', '#f59e0b'];
    const color = colors[Math.floor(Math.random() * colors.length)];
    return `data:image/svg+xml,${encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 600">
        <defs>
          <linearGradient id="storyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color:${color};stop-opacity:0.9" />
            <stop offset="100%" style="stop-color:#0f172a;stop-opacity:1" />
          </linearGradient>
        </defs>
        <rect width="400" height="600" fill="url(#storyGrad)"/>
        <text x="200" y="300" font-size="48" text-anchor="middle" fill="white" font-family="Arial">📸</text>
        <text x="200" y="360" font-size="18" text-anchor="middle" fill="rgba(255,255,255,0.8)" font-family="Arial">New Story</text>
      </svg>
    `)}`;
  };

  const handleSelectMedia = () => {
    setPreview(generatePlaceholder());
  };

  const handlePost = () => {
    if (!preview) return;
    
    setPosting(true);
    setTimeout(() => {
      createPost({
        content: '',
        mediaType,
        mediaUrl: preview,
        isLocked: false,
        isStory: true,
        expiresAt: new Date(Date.now() + 24 * 60 * 60 * 1000)
      });
      setSuccess(true);
      setTimeout(onClose, 1500);
    }, 1000);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="create-story-modal animate-slide-up" onClick={e => e.stopPropagation()}>
        <div className="modal-handle" />
        
        {success ? (
          <div className="story-success">
            <div className="success-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
              </svg>
            </div>
            <h3>Story Posted!</h3>
            <p>Your story is now live for 24 hours</p>
          </div>
        ) : (
          <>
            <div className="modal-header">
              <h2>Create Story</h2>
              <button className="close-btn" onClick={onClose}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 6L6 18M6 6l12 12"/>
                </svg>
              </button>
            </div>

            <div className="media-type-tabs">
              <button 
                className={`type-tab ${mediaType === 'image' ? 'active' : ''}`}
                onClick={() => setMediaType('image')}
              >
                📷 Photo
              </button>
              <button 
                className={`type-tab ${mediaType === 'video' ? 'active' : ''}`}
                onClick={() => setMediaType('video')}
              >
                🎬 Video
              </button>
            </div>

            <div className="story-preview-area" onClick={handleSelectMedia}>
              {preview ? (
                <img src={preview} alt="Story preview" />
              ) : (
                <div className="upload-placeholder">
                  <div className="upload-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                      <circle cx="8.5" cy="8.5" r="1.5"/>
                      <polyline points="21 15 16 10 5 21"/>
                    </svg>
                  </div>
                  <span>Tap to select {mediaType}</span>
                  <span className="upload-hint">Your story will disappear after 24 hours</span>
                </div>
              )}
            </div>

            <div className="story-options">
              <label className="story-option">
                <span>Allow replies</span>
                <input type="checkbox" defaultChecked />
              </label>
              <label className="story-option">
                <span>Save to highlights</span>
                <input type="checkbox" />
              </label>
            </div>

            <button 
              className={`post-story-btn ${posting ? 'posting' : ''}`}
              onClick={handlePost}
              disabled={!preview || posting}
            >
              {posting ? (
                <span className="spinner" />
              ) : (
                'Share Story'
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CreateStoryModal;
